import { useState, FC } from "react"
import "./tooltip.scss"

interface ITooltip {
  children: React.ReactNode
  direction?: "right" | "bottom"
  tooltipRelative?: boolean
  tooltipAbsolute?: boolean
}
const Tooltip: FC<ITooltip> = ({
  children,
  direction,
  tooltipRelative,
  tooltipAbsolute
}) => {
  const [active, setActive] = useState(false)

  const showTip = () => {
    setActive(true)
  }

  const hideTip = () => {
    setActive(false)
  }

  const toggleTooltip = () => {
    setActive(!active)
  }

  return (
    <div
      onClick={toggleTooltip}
      className={`ocs-tooltip-container icon-danger sm 
      ${tooltipRelative ? "tooltip-static" : ""}
      ${tooltipAbsolute ? "tooltip-absolute" : ""}
      `}
      onMouseEnter={showTip}
      onMouseLeave={hideTip}
    >
      {active && (
        <div className={`ocs-tooltip-popup ${direction || "top"}`}>
          <span>{children}</span>
        </div>
      )}
    </div>
  )
}

export default Tooltip
